module.exports = __webpack_public_path__ + "static/media/text-anonymization-activity-tracker-logo.281e35d9.png";